module.exports = __webpack_public_path__ + "img/frank-01.d60fdf42.png";